import axios from "axios";

const REACT_APP_VEHICLES_API = process.env.REACT_APP_VEHICLES_API;

export const getScheduledFWUpdates = async (
  query,
  page = 1,
  cancelToken,
  filterBy = "",
  sortBy = "",
) => {
  let url = `${REACT_APP_VEHICLES_API}/device_firmware_loads?results_per_page=100&page=${page}`;
  if (filterBy) {
    url = `${url}&${filterBy}`;
  }
  if (sortBy) {
    url = `${url}&sort=${sortBy}`;
  }
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: response.data, hasNextPage: response.data.has_next_page };
  } catch (e) {
    return { detail: e.response?.data?.error };
  }
};

export const getScheduledFWUpdateByID = async (
  id,
  cancelToken,
) => {
  const url: string = `${REACT_APP_VEHICLES_API}/device_firmware_loads/${id}`;
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return response.data.data;
  } catch (e) {
    return { detail: e.response?.data?.error };
  }
};

export const deleteScheduledFWUpdate = async (id) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/device_firmware_loads/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response };
  } catch (e) {
    return { detail: e.response?.data?.error };
  }
};


export const uploadScheduledFWToDevices = async (imeis: string[], id: number, dateFrom: string, dateTo: string, ignitionOn: boolean, ignitionOff: boolean, scheduledUploadID?: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    let url: string = `${REACT_APP_VEHICLES_API}/device_firmware_loads`;
    if(scheduledUploadID) {
      url += `/${scheduledUploadID}`
    }
    const method: "post" | "put" = scheduledUploadID ? "put" : "post";
    const response = await axios({
      method,
      url,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        device_firmware_id: id,
        allowed_from: dateFrom,
        allowed_to: dateTo,
        only_ignition_on: ignitionOn,
        only_ignition_off: ignitionOff,
        imeis: imeis
      },
    });
    return { data: response };
  } catch (e) {
    const responseData = e.response?.data;
    if(scheduledUploadID) {
      const detail = responseData?.validation_errors?.length
        ? responseData.validation_errors.map((v) => `${v.msg_key}: ${v.msg}`).join(", ")
        : responseData?.msg ?? "Unknown error";
      return detail;
    } else {
      return responseData?.errors
        .map((error) => {
          const [field, message] = Object.entries(error)[0];
          return `${field}: ${message}`;
        })
        .join(", ");
    }
  }
};